import React from 'react'
import Lottie from 'react-lottie'
import { Waypoint } from 'react-waypoint'

import animation22 from '../../images/lotties/animation22.json'

const animationOptions = {
  loop: false,
  autoplay: false,
  animationData: animation22,
  assetsPath: 'https://dev-interaktiv-mf.tagesanzeiger.ch/2023/schaad-kiribati-msf/animation22/',
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export class Animation22 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      play: false
    }
  }

  render() { 
  return (
    <div
      className={`picture ${this.props.className ? this.props.className : ''}`}
      style={this.props.style}
    >
      {
        <Lottie
           isStopped={!this.state.play}
           options={animationOptions}
           isClickToPauseDisabled={true}
        />
      }
       
      {this.props.children && <div className='inner'>{this.props.children}</div>}
      <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              this.setState({ play: true })
            }}
            onLeave={event => {
              this.setState({ play: false })
            }}
          >
            <span></span>
      </Waypoint>
    </div>
  )
 }
}

